/* AUTO-GENERATED. Do not edit by hand. */

/**
 * @remixicon/react v4.1.0 - Apache-2.0
 */
import type { RemixiconComponentType } from '../types'

/**
 * RiArrowLeftLine icon component from Remix Icon set.
 * 
 * @param props - RemixiconProps
 * @returns JSX element representing the RiArrowLeftLine icon
 */
const RiArrowLeftLine: RemixiconComponentType = (props): JSX.Element => {
  // Extract RemixiconProps
  const {
    color = 'currentColor',
    size = 24,
    ...rest
  } = props

  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      fill={color}
      width={size}
      height={size}
      {...rest}
    >
      <path fill="currentColor" d="M7.828 11H20v2H7.828l5.364 5.364l-1.414 1.414L4 12l7.778-7.778l1.414 1.414z"/>
    </svg>
  )
}

export default RiArrowLeftLine
